import { collection, getDocs } from 'firebase/firestore';
import { firestore } from '../helpers/firebase';

const getUsers = async () => {
  const returnUsers = await getDocs(collection(firestore, 'users'))
    .then((snapshot) => {
      let users = {};
      snapshot.forEach((doc) => { users = { ...users, [doc.id]: doc.data() }; });
      return { error: false, users };
    })
    .catch(error => ({ error: true, message: error.message, users: [] }));
  return returnUsers;
};

export default getUsers;
